import * as React from "react";

const CaretUp: React.FC = () => {
    return <svg width="10px" height="5px" viewBox="0 0 10 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-570.000000, -365.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(491.000000, 135.000000)">
                    <polygon points="10 5 5 0 0 5"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(CaretUp);
